export const SET_CODE = 'set_code';
export const SET_DATA = 'set_data';
export const SET_IS_VALIDATING = 'set_is_validating';

const state = () => ({
  code: null,
  data: {},
  isValidating: false,
});

const actions = {};

const mutations = {
  [SET_CODE] (state, code) {
    state.code = code;
    state.data = {}; // clear data
  },
  [SET_DATA] (state, data) {
    state.data = data;
  },
  [SET_IS_VALIDATING] (state, isValidating) {
    state.isValidating = isValidating;
  },
};

const getters = {};

export default {
  state,
  mutations,
  actions,
  getters,
};
